import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Cloud_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.55072 7.03818C6.16035 5.37456 7.74898 4.25 9.54401 4.25H10C12.3983 4.25 14.3715 6.06993 14.6139 8.40406C16.3493 8.42385 17.75 9.83681 17.75 11.5769C17.75 13.3294 16.3294 14.75 14.5769 14.75H6.11539C3.98059 14.75 2.25 13.0194 2.25 10.8846V10.6955C2.25 8.79197 3.69678 7.22631 5.55072 7.03818ZM9.54401 5.75C8.31 5.75 7.22668 6.57098 6.893 7.75901L6.88314 7.79411C6.76271 8.22291 6.3717 8.51923 5.92631 8.51923C4.72437 8.51923 3.75 9.4936 3.75 10.6955V10.8846C3.75 12.191 4.80902 13.25 6.11539 13.25H14.5769C15.5009 13.25 16.25 12.5009 16.25 11.5769C16.25 10.6529 15.5009 9.90385 14.5769 9.90385H13.8889C13.4747 9.90385 13.1389 9.56806 13.1389 9.15385V8.88889C13.1389 7.15533 11.7336 5.75 10 5.75H9.54401Z"
            />
        </SvgStyled>
    );
};

export default Cloud_sm;
